export class BilEventSnackbarOpen  {
  constructor(public readonly message: string, public readonly type: string, public readonly duration?: number) {
  }
  public static EventSelector(eventInfo: any): boolean {
    return eventInfo instanceof BilEventSnackbarOpen;
  }
}
